
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/appointments/book/error",
      function () {
        return require("private-next-pages/user/appointments/book/error/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/appointments/book/error"])
      });
    }
  